import { Skeleton } from '@/components/ui/skeleton'
import { Card, CardContent } from '@/components/ui/card'

export function SurveyFormSkeleton() {
  return (
    <div className="space-y-6">
      {/* Header Section */}
      <div className="flex flex-col gap-6">
        <div className="flex items-center justify-between gap-4">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-6 w-24 rounded-full" />
        </div>

        <div className="space-y-4">
          {/* Progress bar */}
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <Skeleton className="h-4 w-16" />
              <Skeleton className="h-4 w-32" />
            </div>
            <Skeleton className="h-2 w-full" />
          </div>

          {/* Page indicator */}
          <div className="flex items-center justify-between">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-40" />
          </div>
        </div>
      </div>

      {/* Questions Section */}
      <div className="space-y-3 max-w-4xl mx-auto">
        <Skeleton className="h-6 w-48 mb-4" />

        {[1, 2, 3].map((i) => (
          <Card key={i}>
            <CardContent className="p-4 space-y-3">
              <div className="flex items-start gap-3">
                <Skeleton className="h-4 w-8 shrink-0" />
                <Skeleton className="h-4 w-full" />
              </div>
              <div className="flex gap-2 justify-center">
                {[1, 2, 3, 4, 5].map((j) => (
                  <Skeleton key={j} className="h-10 w-10 rounded-full" />
                ))}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Navigation Section */}
      <div className="flex justify-between max-w-4xl mx-auto">
        <Skeleton className="h-10 w-28" />
        <Skeleton className="h-10 w-24" />
      </div>
    </div>
  )
}
